import { render, staticRenderFns } from "./AddProvider.vue?vue&type=template&id=4cb89183&scoped=true"
import script from "./AddProvider.vue?vue&type=script&lang=js"
export * from "./AddProvider.vue?vue&type=script&lang=js"
import style0 from "./AddProvider.vue?vue&type=style&index=0&id=4cb89183&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb89183",
  null
  
)

export default component.exports